import React, { useState } from "react";
import ExpandPlusIcon from "../Icons/ExpandPlusIcon";
import ExpandHyphenIcon from "../Icons/ExpandHyphenIcon";

interface IExpandableAccordion{
  icon: JSX.Element | null;
  title: string;
  removeBorder?: boolean;
  titleJsx?: JSX.Element;
  description?: string | JSX.Element;
  onExpand?: (title: string) => void;
}

const ExpandableAccordion = ({ icon, title, description,
  onExpand, titleJsx, removeBorder=false }: IExpandableAccordion) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const handleExpandClick = () =>{
    setIsExpanded(!isExpanded);
    if (onExpand && !isExpanded) {
      onExpand(title);
    }
  };

  return (
    <div
      className={`p-3 bg-white flex flex-col gap-2
        ${removeBorder? "" : " rounded-lg border border-gray-4"} cursor-pointer`}
      onClick={handleExpandClick} >
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          {icon && <div>
            {icon}
          </div>}
          <div className="text-sm font-semibold">{titleJsx ? titleJsx : title}</div>
        </div>
        {description &&
        <div
          className="cursor-pointer w-6 h-6 flex items-center justify-center bg-violet-4 rounded-full" >
          {isExpanded ? <ExpandHyphenIcon /> : <ExpandPlusIcon /> }
        </div>}
      </div>
      {description && isExpanded &&
      <div className="text-sm">
        {description}
      </div>}
    </div>
  );
};

export default ExpandableAccordion;
